import axios from 'axios';
import { API_BASE_URL } from '../../../config';

export class CustomPaymentTypesApi {
  static getCustomPaymentTypes = (organizationId) => {
    return axios.get(`${API_BASE_URL}/custom-payment-types`, {
      params: { organizationId },
    });
  };

  static getCustomPaymentTypesForm = (params = {}) => {
    return axios.get(`${API_BASE_URL}/custom-payment-types/form`, {
      params,
    });
  };

  static getCustomPaymentType = (organizationId, customPaymentTypeId) => {
    return axios.get(
      `${API_BASE_URL}/custom-payment-types/${customPaymentTypeId}`,
      {
        params: { organizationId },
      },
    );
  };

  static createCustomPaymentType = (organizationId, customPaymentTypeData) => {
    return axios.post(
      `${API_BASE_URL}/custom-payment-types`,
      customPaymentTypeData,
      {
        params: { organizationId },
      },
    );
  };

  static updateCustomPaymentType = (
    organizationId,
    customPaymentTypeId,
    customPaymentTypeData,
  ) => {
    return axios.put(
      `${API_BASE_URL}/custom-payment-types/${customPaymentTypeId}`,
      customPaymentTypeData,
      {
        params: { organizationId },
      },
    );
  };

  static deleteCustomPaymentType = (organizationId, customPaymentTypeId) => {
    return axios.delete(
      `${API_BASE_URL}/custom-payment-types/${customPaymentTypeId}`,
      {
        params: { organizationId },
      },
    );
  };

  static toggleCustomPaymentType = (organizationId, customPaymentTypeId) => {
    return axios.patch(
      `${API_BASE_URL}/custom-payment-types/${customPaymentTypeId}/toggle`,
      {},
      {
        params: { organizationId },
      },
    );
  };

  static getDefaultCreateRefundConfig = () => {
    return axios.get(
      `${API_BASE_URL}/custom-payment-types/default-create-refund-config`,
    );
  };
}
